import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Setting up Instagram", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "dialog-content pb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "facebook-connect-alert__content" }, [
    /*#__PURE__*/_createTextVNode(" To ensure Reply200 functions correctly for your Instagram ad campaigns, you need to connect your Instagram Professional Account(s) to the relevant Facebook Page(s). Learn how to do this "),
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      href: "https://www.facebook.com/business/help/connect-instagram-to-page"
    }, "here"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)
const _hoisted_3 = { class: "dialog-actions mt-0" }

import { useDialogStore } from '@/stores/dialogs';
import VButton from '../VButton.vue';
import SettingsDialog from './SettingsDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FacebookConnectAlert',
  setup(__props) {

const dialogStore = useDialogStore()

const close = () => {
  dialogStore.close()
  dialogStore.open(SettingsDialog, { page: "social" })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(VButton, { onClick: close }, {
        default: _withCtx(() => [
          _createTextVNode("Got it")
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})